<template>
  <el-tooltip :disable="!extraOption || !tooltip" :content="$store.getters.language === 'zh'?extraOption.chineseName:extraOption.englishName" placement="bottom">
    <cargo-advance-select
      :disabled="disabled"
      :select-type="selectTypeNames.basic_data_Office"
      :cache="false"
      filterable
      :clearable="clearable"
      :default-value="officeId||''"
      :static-options="options"
      :tag-name="tagName"
      :tag-value="tagValue"
      :placeholder="placeholder"
      @parentCallBack="p=>{$emit('change',p)}"
    />
  </el-tooltip>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { sleep } from '@/utils/commonUtil'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getBranchByLevel, getCacheListByKey } from '@/utils/basicDataCache'
import { getUserByTreeOffice } from '@/api/office'

export default {
  name: 'CargoOfficeSelect',
  components: { cargoAdvanceSelect },
  props: {
    haveHq: { type: Boolean, default: true }, // 是否去掉HQ，默认不去掉
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    officeId: { type: Number, default: 0 },
    tagName: { type: String, default: '' }, // 要取来显示到select框内的字段名
    tagValue: { type: String, default: '' }, // select的value对应的字段，默认id
    isRegionalCommission: { type: Boolean, default: false }, // 是否是区域委托
    tooltip: {
      type: Boolean,
      default: false
    },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      selectTypeNames: TYPE_NAMES,
      officeList: [],
      originOptions: [],
      extraOption: {}
    }
  },
  computed: {
    options() {
      if (this.extraOption && !this.originOptions.includes(this.extraOption)) {
        return [this.extraOption, ...this.originOptions]
      }
      return this.originOptions
    }
  },
  watch: {
    officeId: {
      immediate: true,
      async handler(newVal, oldVal) {
        // 第一次进入，暂停一下，在created之后执行
        if (typeof oldVal === 'undefined') {
          await sleep(0)
        }
        await this.handleOfficeIdChange()
      }
    },
    isRegionalCommission() {
      this.handleOfficeIdChange()
    }
  },
  async created() {
    await this.init()
    this.visible = true
  },
  methods: {
    async init() {
      if (this.isRegionalCommission) {
        this.officeList = getBranchByLevel(this.officeId)
      } else {
        if (this.$store.getters.isAdmin) {
          this.officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
        }
        if (!this.officeList || this.officeList.length <= 0) {
          this.officeList = await getUserByTreeOffice().then(res => res.data)
        }
      }
      if (!this.haveHq) {
        this.officeList = this.officeList.filter(p => p.code !== 'HQ')
      }
    },
    async handleOfficeIdChange() {
      this.originOptions = []
      await this.init()
      for (const item of this.officeList) {
        if (item.officeId === this.officeId) continue
        this.originOptions.push(item)
      }
      this.handleDefaultValue()
    },
    async handleDefaultValue() {
      this.extraOption = {}
      if (!this.officeId) return
      for (const item of this.originOptions) {
        if (item.officeId === this.officeId) return
      }
      await this.init()
      const office = this.officeList.find(p => p.officeId === this.officeId)
      this.extraOption = office || null
    }
  }
}
</script>

<style>
</style>
